import { useState } from "react";
import { Link } from "react-router-dom";
import { useLang, track } from "@/context/LanguageContext";
import { Reveal, ImageReveal } from "@/components/Reveal";
import { SectionLabel } from "@/components/Editorial";
import { PageHead, CTABand } from "@/components/Shared";
import { EVENTS } from "@/data/config";

function EventItem({ e, i }) {
  return (
    <Reveal delay={i * 0.06}>
      <article className="grid grid-cols-12 items-center gap-6 border-b border-onyx/15 py-8" data-testid={`event-${e.id}`}>
        <ImageReveal src={e.image} alt={e.title} className="col-span-12 aspect-[16/10] md:col-span-4" />
        <div className="col-span-12 md:col-span-5">
          <h3 className="font-serif text-4xl leading-tight md:text-5xl">{e.title}</h3>
          <p className="mt-4 max-w-md font-sans text-sm leading-relaxed text-onyx/65">{e.desc}</p>
        </div>
        <div className="col-span-12 space-y-2 md:col-span-3 md:text-right">
          <p className="label text-terracotta">{e.date}</p>
          {e.time && <p className="label text-clay">{e.time}</p>}
          <p className="font-sans text-sm text-onyx/60">{e.location}</p>
        </div>
      </article>
    </Reveal>
  );
}

export default function Events() {
  const { t } = useLang();
  const [tab, setTab] = useState("upcoming");
  const list = (EVENTS[tab] || []).filter((e) => !e.hidden);
  return (
    <>
      <PageHead label={t.events.label} title={t.events.title} lead={t.events.intro} />
      <section className="bg-petal" data-testid="events-list">
        <div className="mx-auto max-w-[1600px] px-6 py-16 md:px-12 md:py-24">
          <div className="flex gap-8 border-b border-onyx/15 pb-6">
            {["upcoming", "past"].map((k) => (
              <button
                key={k}
                onClick={() => setTab(k)}
                data-testid={`events-tab-${k}`}
                className={`label transition-opacity duration-300 ${tab === k ? "text-onyx opacity-100" : "text-onyx/40 hover:opacity-70"}`}
              >
                {t.events[k]}
              </button>
            ))}
          </div>
          <div className="mt-8">
            {list.length ? list.map((e, i) => <EventItem key={e.id} e={e} i={i} />) : (
              <div className="py-20 text-center md:py-28" data-testid="events-empty">
                <p className="mx-auto max-w-2xl font-serif text-4xl leading-snug text-onyx md:text-5xl">{t.events.empty}</p>
                <p className="mx-auto mt-6 max-w-md font-sans text-base leading-relaxed text-onyx/60">{t.events.emptySub}</p>
                <Link
                  to="/contact"
                  onClick={() => track("events_notify_click")}
                  className="label mt-10 inline-block border border-onyx px-10 py-5 transition-colors duration-500 hover:bg-onyx hover:text-petal"
                  data-testid="events-notify-cta"
                >
                  {t.events.notifyCta} →
                </Link>
              </div>
            )}
          </div>
        </div>
      </section>
      <CTABand />
    </>
  );
}
